<template>
  <aside class="legacy-shell-placeholder"></aside>
</template>

<style scoped>
.legacy-shell-placeholder {
  display: none;
}
</style>
